module.exports = __webpack_public_path__ + "media/images/prizes__sidebar--image-f89da4b4e0460a3bc97136ef83f18575.png";